/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // Npm: Apollo client for handling graphql request.

/*
 * EXPORTS
 */
export default gql`
  query CustomerAccountReadAllQuery(
    $batchId: String
    $customerAccountIds: [ID!]
  ) {
    CustomerAccountReadAll(
      batchId: $batchId
      customerAccountIds: $customerAccountIds
    ) {
      id
      createdAt
      displayName
      enableLossProtection
      chargeOnDelivered
      batchId
      message
      status
      _totalCount
      Rate {
        id
        displayName
      }
      Route {
        id
        displayName
      }
      Smpp {
        id
        displayName
        batchId
        ip
        rxPort
        txPort
        username
        password
        sessionTimeoutInterval
        enquireLinkInterval
        sourceAddressTon
        sourceAddressNpi
        destinationAddressTon
        destinationAddressNpi
        trunkType
        sessionAllowed
        tps
        debuggingLevel
        message
        status
      }
    }
  }
`;
